module.exports = __webpack_public_path__ + "img/d3.860f3a82.jpg";